'use strict';

var _defineProperty = require("/home/runner/work/neoswap-app-react/neoswap-app-react/node_modules/@babel/runtime/helpers/defineProperty.js").default;
Object.defineProperty(exports, '__esModule', {
  value: true
});
var UmiError = require('./UmiError.cjs');

/** @category Errors */
class SdkError extends UmiError.UmiError {
  constructor(message, cause) {
    super(message, 'sdk', undefined, cause);
    _defineProperty(this, "name", 'SdkError');
  }
}
exports.SdkError = SdkError;
//# sourceMappingURL=SdkError.cjs.map